<a (click)="!mustShowAviso ? file.click() : showAvisoDocumentacao()">
  <input #file style="display: none" type="file" (change)="emitFile($event)" accept=".gif,.jpg,.jpeg,.png,.bmp" />

  <img *ngIf="!imgUrl" src="../../../../../assets/images/examples/car.png" [alt]="descricao" />

  <div *ngIf="imgUrl">
    <img [src]="imgUrl" [alt]="descricao" />

    <span class="file-name text-overflow-points">{{fileName}}</span>
  </div>
</a>
